<template>
  <span class="flex">
    <component class="gwf-icon" :is="iconKebabCase" v-bind="$attrs" v-on="$listeners"></component>
  </span>
</template>

<script>
import ActivateUser from '@/components/icons/activate-user.vue'
import Archive from '@/components/icons/archive.vue'
import ArrowDown from '@/components/icons/arrow-down.vue'
import ArrowFirst from '@/components/icons/arrow-first.vue'
import ArrowLast from '@/components/icons/arrow-last.vue'
import ArrowLeft from '@/components/icons/arrow-left.vue'
import ArrowRight from '@/components/icons/arrow-right.vue'
import ArrowUp from '@/components/icons/arrow-up.vue'
import ArrowUpDown from '@/components/icons/arrow-up-down.vue'
import Assign from '@/components/icons/assign.vue'
import Battery0 from '@/components/icons/battery-0.vue'
import Battery1 from '@/components/icons/battery-1.vue'
import Battery2 from '@/components/icons/battery-2.vue'
import Battery3 from '@/components/icons/battery-3.vue'
import Battery4 from '@/components/icons/battery-4.vue'
import Battery5 from '@/components/icons/battery-5.vue'
import Building from '@/components/icons/building.vue'
import Calendar from '@/components/icons/calendar.vue'
import Cancel from '@/components/icons/cancel.vue'
import Chart from '@/components/icons/chart.vue'
import Checkmark from '@/components/icons/checkmark.vue'
import ChevronDown from '@/components/icons/chevron-down.vue'
import Close from '@/components/icons/close.vue'
import CloudUpload from '@/components/icons/cloud-upload.vue'
import Code from '@/components/icons/code.vue'
import Cog from '@/components/icons/cog.vue'
import Company from '@/components/icons/company.vue'
import Dashboard from '@/components/icons/dashboard.vue'
import Dashboard2 from '@/components/icons/dashboard2.vue'
import Delete from '@/components/icons/delete.vue'
import DemoCreator from '@/components/icons/demo-creator.vue'
import DevicesAfm from '@/components/icons/devices_afm.vue'
import DevicesOther from '@/components/icons/devices_other.vue'
import Download from '@/components/icons/download.vue'
import DownloadOutline from '@/components/icons/download-outline.vue'
import DragVertical from '@/components/icons/drag-vertical.vue'
import Edit from '@/components/icons/edit.vue'
import Error from '@/components/icons/error.vue'
import ExternalLink from '@/components/icons/external-link.vue'
import Eye from '@/components/icons/eye.vue'
import EyeOutline from '@/components/icons/eye-outline.vue'
import FilePlus from '@/components/icons/file-plus.vue'
import FileZip from '@/components/icons/file-zip.vue'
import Filters from '@/components/icons/filters.vue'
import FiltersClear from '@/components/icons/filters-clear.vue'
import FlowTree from '@/components/icons/flow-tree.vue'
import Globe from '@/components/icons/globe.vue'
import Group from '@/components/icons/group.vue'
import History from '@/components/icons/history.vue'
import Import from '@/components/icons/import.vue'
import Info from '@/components/icons/info.vue'
import KeyAlt from '@/components/icons/key-alt.vue'
import Key from '@/components/icons/key.vue'
import Link2 from '@/components/icons/link.vue'
import LogOut from '@/components/icons/log-out.vue'
import MapPin from '@/components/icons/map-pin.vue'
import MeasuringPoint from '@/components/icons/measuring-point.vue'
import MenuToggler from '@/components/icons/menu-toggler.vue'
import Merge from '@/components/icons/merge.vue'
import MeterIcon from '@/components/icons/meter-icon.vue'
import Minus from '@/components/icons/minus.vue'
import More from '@/components/icons/more.vue'
import Notification from '@/components/icons/notification.vue'
import Orders from '@/components/icons/orders.vue'
import PasswordHide from '@/components/icons/password-hide.vue'
import PasswordShow from '@/components/icons/password-show.vue'
import Plus from '@/components/icons/plus.vue'
import Profile from '@/components/icons/profile.vue'
import Profile2 from '@/components/icons/profile2.vue'
import Readout from '@/components/icons/readout.vue'
import Refresh from '@/components/icons/refresh.vue'
import Register from '@/components/icons/register.vue'
import Restore from '@/components/icons/restore.vue'
import Report from '@/components/icons/report.vue'
import Search from '@/components/icons/search.vue'
import Sonico from '@/components/icons/sonico.vue'
import Sort from '@/components/icons/sort.vue'
import SpinnerBtn from '@/components/icons/spinner-btn.vue'
import Spinner2 from '@/components/icons/spinner2.vue'
import Success from '@/components/icons/success.vue'
import Transfer from '@/components/icons/transfer.vue'
import Truck from '@/components/icons/truck.vue'
import Tablet from '@/components/icons/tablet.vue'
import UserAdd from '@/components/icons/user-add.vue'
import UserSolidSquare from '@/components/icons/user-solid-square.vue'
import Users from '@/components/icons/users.vue'
import Volume2 from '@/components/icons/volume2.vue'
import Warn from '@/components/icons/warn.vue'
import Invoice from '@/components/icons/invoice.vue'
import ExpandDown from '@/components/icons/expand-down.vue'
import ExpandUp from '@/components/icons/expand-up.vue'
import ZoomOut from '@/components/icons/zoom-out.vue'
import ChartArea from '@/components/icons/chart-area.vue'

export default {
  inheritAttrs: false,
  computed: {
    iconKebabCase() {
      // Camel case icon name converted to kebab case icon name
      return this.icon.replace('_', '-')
    },
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  components: {
    ActivateUser,
    Archive,
    ArrowDown,
    ArrowFirst,
    ArrowLast,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    ArrowUpDown,
    Assign,
    Battery0,
    Battery1,
    Battery2,
    Battery3,
    Battery4,
    Battery5,
    Building,
    Calendar,
    Cancel,
    Chart,
    ChartArea,
    Checkmark,
    ChevronDown,
    Close,
    CloudUpload,
    Code,
    Cog,
    Company,
    Dashboard,
    Dashboard2,
    Delete,
    DemoCreator,
    DevicesAfm,
    DevicesOther,
    Download,
    DownloadOutline,
    DragVertical,
    Edit,
    Error,
    ExternalLink,
    Eye,
    EyeOutline,
    FilePlus,
    FileZip,
    Filters,
    FiltersClear,
    FlowTree,
    Globe,
    Group,
    History,
    Import,
    Info,
    KeyAlt,
    Key,
    Link2,
    LogOut,
    MapPin,
    MeasuringPoint,
    MenuToggler,
    Merge,
    MeterIcon,
    Minus,
    More,
    Notification,
    Orders,
    PasswordHide,
    PasswordShow,
    Plus,
    Profile,
    Profile2,
    Readout,
    Refresh,
    Register,
    Restore,
    Report,
    Search,
    Sonico,
    Sort,
    SpinnerBtn,
    Spinner2,
    Success,
    Transfer,
    Truck,
    Tablet,
    UserAdd,
    UserSolidSquare,
    Users,
    Volume2,
    Warn,
    Invoice,
    ExpandDown,
    ExpandUp,
    ZoomOut,
  },
}
</script>
<style scoped>
.gwf-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
  vertical-align: middle;
}
</style>
